import { Notification, NotificationType } from '../models/notification';
import { UserRole } from '../models/user';
import { AppRoutePaths } from './enums';

export function notificationsRedirectTo(
  notification: Notification,
  userRole: UserRole,
) {
  let redirectUrl = '/home';
  const jsonData = notification?.data ?? {};

  if (notification.type === NotificationType.ART_ACTIVITY) {
    if (userRole === UserRole.FINAL_ART) {
      redirectUrl = `${AppRoutePaths.ART_ACTIVITY}`.replace(
        ':id',
        `${jsonData['activityId']}`,
      );
    }

    if (userRole === UserRole.VENDOR) {
      redirectUrl = `${AppRoutePaths.ACTIVITIES}`;
    }
  } else if (notification.type === NotificationType.LAYOUT) {
    if (userRole === UserRole.FINAL_ART) {
      redirectUrl = `${AppRoutePaths.ART_ACTIVITY}`.replace(
        ':id',
        `${jsonData['activityId']}`,
      );
    }

    if (userRole === UserRole.VENDOR) {
      redirectUrl = `${AppRoutePaths.ACTIVITY_LAYOUTS}`;
    }
  } else if (notification.type === NotificationType.PAYMENT_SLIP) {
    redirectUrl = `${AppRoutePaths.PAYMENT_SLIP_LIST}`;
  } else if (notification.type === NotificationType.PRODUCTION_APPROVAL) {
    if (userRole === UserRole.VENDOR) {
      redirectUrl = `${AppRoutePaths.ORDERS_FIRST_PIECE}`;
    }
  } else if (notification.type === NotificationType.BALANCE_REQUEST_APPROVAL) {
    redirectUrl = `${AppRoutePaths.COMPANY}`;
  } else if (notification.type === NotificationType.STOCK_REQUEST) {
    redirectUrl = `${AppRoutePaths.STOCK_REQUEST_LIST}`;
  } else if (notification.type === NotificationType.WITHDRAWAL) {
    redirectUrl = `${AppRoutePaths.ORDER_WITHDRAWAL}`;
  } else if (notification.type === NotificationType.ORDER_PRICE) {
    redirectUrl = `${AppRoutePaths.FINANCIAL_CHECK}`;
  } else if (notification.type === NotificationType.MATERIAL_ASSOCIATED) {
    redirectUrl = `${AppRoutePaths.ORDER_MATERIALS_PENDING}`;
  }

  return redirectUrl;
}
